import React from 'react';
import classNames from 'classnames';
import {
  EditableInlineText,
  EditableLink,
  useContentElementConfigurationUpdate
} from 'pageflow-scrolled/frontend';

import styles from './CtaButton.module.css';

export function CtaButton({configuration, sectionProps}) {
  const updateConfiguration = useContentElementConfigurationUpdate();

  return (
    <div className={classNames(styles.wrapper,
                               styles[`layout-${sectionProps.layout}`])}>
      <EditableLink href={configuration.href || configuration.url}
                    openInNewTab={configuration.openInNewTab}
                    className={styles.cta}
                    onChange={value => {updateConfiguration(value)}}
                    linkPreviewPosition="above"
                    actionButtonPosition="outsideLeft">
          <EditableInlineText value={configuration.text}
                              onChange={text => updateConfiguration({text})}
                              placeholder="Text" />
      </EditableLink>
    </div>
  );
}
